import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { Card, Typography } from "antd";

const { Title } = Typography;

const CircularPercentage = ({ vacancies, taken }) => {
    const targetPercent = vacancies > 0 ? Math.round((taken / vacancies) * 100) : 0;

    
    // Animate percentage counting up
    const [displayPercent, setDisplayPercent] = useState(0);

    useEffect(() => {
        let start = 0;
        const step = targetPercent / 30;
        const interval = setInterval(() => {
            start += step;
            if (start >= targetPercent) {
                setDisplayPercent(targetPercent);
                clearInterval(interval);
            } else {
                setDisplayPercent(Math.round(start));
            }
        }, 30);
        return () => clearInterval(interval);
    }, [targetPercent]);

    // Dynamic color based on percentage
    let fillColor = "#d32f2f"; // default red
    if (targetPercent >= 75) {
        fillColor = "#2e7d32"; // green
    } else if (targetPercent >= 25) {
        fillColor = "#fbc02d"; // yellow
    }

    const data = [
        { name: "Completed", value: targetPercent },
        { name: "Remaining", value: 100 - targetPercent },
    ];

    const COLORS = [fillColor, "#e0e0e0"];

    return (
        // <Card
        //     size="small"
        //     style={{
        //         width:'fit-content',
        //         borderRadius: 10,
        //         textAlign: "center",
        //     }}
        //     bodyStyle={{ padding: "12px" }}
        // >
        //     <PieChart width={80} height={80}>
        //         <Pie
        //             data={data}
        //             cx="50%"
        //             cy="50%"
        //             innerRadius={20}
        //             outerRadius={35}
        //             startAngle={90}
        //             endAngle={-270}
        //             dataKey="value"
        //             isAnimationActive={true}
        //             animationDuration={100}
        //         >
        //             {data.map((entry, index) => (
        //                 <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        //             ))}

        //             {/* Center label */}
        //             <text
        //                 x="50%"
        //                 y="50%"
        //                 textAnchor="middle"
        //                 dominantBaseline="middle"
        //                 style={{ fontSize: "12px", fontWeight: "bold", fill: "#333" }}
        //             >
        //                 {`${displayPercent}%`}
        //             </text>
        //         </Pie>
        //         <Tooltip />
        //     </PieChart>

        // </Card>
        <>
        
        </>
    );
};

export default CircularPercentage;
